module.exports = __webpack_public_path__ + "static/7-99a79b30fdf827a2319ae0ecfa0d7695.png";